import request from '@/utils/request';

export function getUrls() {
  return request({
    url: 'urls',
    method: 'get',
  });
}
